// VITE_MIGRATION: Expose helpers on window. Under Sprockets, top-level `function`
// declarations leaked to global scope via script concatenation. Under Vite/ESM,
// this file is a module so declarations stay local unless explicitly exported.
// The legacy Handlebars templates read `window.iconSpriteUrl`.
function createIconTag(name, options) {
  options ||= {};

  const wrapperOptions = options.wrapper || {};
  const wrapperTag = wrapperOptions.tag ?? "span";
  const wrapperClass = ["icon-wrapper", `icon-wrapper--${wrapperTag}`, wrapperOptions.class ?? ""].join(" ");

  delete wrapperOptions.tag;
  delete options.wrapper;

  options.class = [`icon icon-${name}`, options.class ?? ""].join(" ");
  const $svg = jQuery("<svg>").attr(options);

  if (options.variations) {
    options.variations.forEach((variation) => {
      const $use = jQuery("<use>")
        .attr("xlink:href", `${iconSpriteUrl()}#icon-${name}-${variation}`)
        .addClass(`icon__use icon__use--${variation}`);

      $svg.append($use);
    });
  } else {
    const $use = jQuery("<use>").attr("xlink:href", `${iconSpriteUrl()}#icon-${name}`);
    $svg.append($use);
  }

  const $wrapper = jQuery(`<${wrapperTag}>`).attr(wrapperOptions).addClass(wrapperClass).append($svg);

  return $wrapper.prop("outerHTML");
}

function iconSpriteUrl() {
  return window.location.origin + window.SparkleConfig.assetPaths.svgIconSprite;
}

window.createIconTag = createIconTag;
window.iconSpriteUrl = iconSpriteUrl;
